import CriacaoLiveGif from './live-onboarding-1.jpg';
import ChatGif from './live-onboarding-2.jpg';
import NavegacaoGif from './live-onboarding-3.jpg';

const VIDEOS = {
  NEW_USER_SECTION: {
    ES: 'https://www.youtube.com/embed/KiQuXnMZHgM?autoplay=true&amp;vol=0',
    PT_BR: 'https://www.youtube.com/embed/uLaEOIa4iGg?autoplay=true&amp;vol=0'
  },
  SALES_AND_EXTRA_MODULE: {
    ES: 'https://player.hotmart.com/embed/MNq7E6kKZA?autoplay=true&amp;vol=0',
    PT_BR: 'https://player.hotmart.com/embed/g9qrmOoORp?autoplay=true&amp;vol=0'
  }
};

const ZENDESK_ARTICLES = {
  CLUB_LIVE: 'article/4410372886669'
};

const STEPS = {
  STEP1: 1,
  STEP2: 2,
  STEP3: 3
};

const STEPS_INFO = [
  {
    id: STEPS.STEP1,
    title: 'webinar_notification.onboarding_live.step1.title',
    description: 'webinar_notification.onboarding_live.step1.description',
    image: CriacaoLiveGif
  },
  {
    id: STEPS.STEP2,
    title: 'webinar_notification.onboarding_live.step2.title',
    description: 'webinar_notification.onboarding_live.step2.description',
    image: ChatGif
  },
  {
    id: STEPS.STEP3,
    title: 'webinar_notification.onboarding_live.step3.title',
    description: 'webinar_notification.onboarding_live.step3.description',
    image: NavegacaoGif
  }
];

const FORWARD_LABEL = {
  [STEPS.STEP1]: 'general.move_forward',
  [STEPS.STEP2]: 'general.move_forward',
  [STEPS.STEP3]: 'general.finish'
};

export { VIDEOS, STEPS, STEPS_INFO, FORWARD_LABEL, ZENDESK_ARTICLES };
